export const DOMAINS = {
    ORDER_PROCESSING: {
      PROD: "https://api-order-processing-gtm.grubhub.com",
      PRE_PROD: "https://api-order-processing-gtm-pp.grubhub.com",
    },
    ORDER_TAKING: {
      PROD: "https://api-gtm.grubhub.com",
      PRE_PROD: "https://api-order-taking-pp.grubhub.com",
    },
  };
  


// WEBPACK FOOTER //
// ./client/app/common/common-constants.js